// extracted by mini-css-extract-plugin
export default {"swButton":"button-module__swButton--LaDov","outlined":"button-module__outlined--wkLmn","contained":"button-module__contained--ZvWuw","fullWidth":"button-module__fullWidth--QkoDf"};